import React from "react";
import MainLayout from "./MainLayout";
import ChecklistOverview from "../common/OnBoarding/SkillChecklist/OnBoardingYourSkills";

const checklistOverviewPage = (props) => <MainLayout component={ChecklistOverview} />;

export default checklistOverviewPage;
